import PriceList from "./components/PriceList";
import AppLayout from "./layout/AppLayout";
import './app.css';



function App() {
  return (
    <div className="app">
      <AppLayout />
    </div>
  );
}

export default App;
